import './JxButton.css';

/**
 * JxButton — simple themed button, styled via className.
 * @param {{
 *   children: React.ReactNode,
 *   onClick: () => void,
 *   className?: string,
 *   disabled?: boolean,
 *   tabIndex?: number,
 * }} props
 */
export function JxButton2({ children, onClick, className = '', disabled = false, tabIndex, ...rest }) {
    return (
        <button
            type="button"
            className={`jx-button ${className}`}
            // className={className}
            onClick={onClick}
            tabIndex={tabIndex}
            disabled={disabled}
            {...rest}
        >
            {children}
        </button>
    );
}

/**
 * className
 * Per default jx-btn-save dirty for hovering
 * possible:
 *
 * icon
 * as child aka
 *  <EventBusyIcon sx={{ fontSize: 11, color: 'var(--j-muted)' >
 *
 *
 *
 * @param {*} props contains label, onClick, className, disabled = false , tabIndex
 * @returns
 */
export default function JxButton({ label, onClick, className = '', disabled = false, tabIndex, icon = null, ...rest }) {
    // if (className === '') {
    //     className = 'jx-btn-save dirty';
    // }

    return (
        <button type="button" className={`jx-button ${className}`} onClick={onClick} tabIndex={tabIndex} disabled={disabled} {...rest}>
            {icon}
            {label}
        </button>
    );
}
